export default __webpack_public_path__ + "static/media/google.11c957ce.svg";